
import { defineComponent, ref } from "vue";
import { GameUtils } from "@/utils/GameUtils";
import 'mosha-vue-toastify/dist/style.css'


export default defineComponent({
  name: "viewGamesAndroidAuth",
  props: {
    deepLink: String,
    gameId: String,
  },
  setup(props){
    const screenMessage = ref('Redirecting to game android app...');
    const errorStatus = ref(false);

    (async() => {
      // console.log(props.deepLink)
      let fetchKey = await GameUtils.fetchAccessTokenKey(props.gameId);
      if(!fetchKey.success){
        if(fetchKey.status == 403){
          screenMessage.value = 'Unable to open this app. Please contact this game developer for invitation.';
        }else{
          screenMessage.value = 'Unable to open app. App authentication error';
        }
        errorStatus.value = true;
      }else{
        // console.log(props.deepLink + '?auth=' + fetchKey);
        if(props.deepLink.includes('://')){
          if(props.deepLink.includes('http://') || props.deepLink.includes('https://')){
            screenMessage.value = 'Unable to open app. Invalid link.';
          }else{
            window.open(props.deepLink + '?auth=' + fetchKey.key);
          }
        }else{
          screenMessage.value = 'Unable to open app. Invalid link.';
        }
      }
    })()

    return {
      screenMessage,
      errorStatus,
    }
  },
});
